import { Router } from "@vaadin/router";

import { installPortfolio } from "@/wc/pages/portfolio/install";
import { installProject } from "@/wc/pages/project/install";
import { Store } from "@/store";

let router: Router;

export type RouteName = "portfolio" | "portfolio-anon" | "project" | "onboarding";

export function useRouter() {
  return router;
}

export function isRouteActive(path: string) {
  try {
    return window.location.pathname.includes(path);
  } catch (error) {
    return false;
  }
}

/**
 * Initialize the router with the given outlet element
 * @param outlet - The DOM element where routes will be rendered
 */
export const initRouter = (outlet: HTMLElement) => {
  if (router) {
    return router;
  }

  router = new Router(outlet);

  // Only allow explicit Router.go navigation's to be spa routed for now
  Router.setTriggers();

  router.setRoutes([
    {
      name: "portfolio",
      path: "/portfolio",
      component: "pages-portfolio",
      action: async () => {
        Store.app.setRoute("portfolio");
        await installPortfolio();
      },
      children: [
        {
          path: "/",
          component: "pages-portfolio-pages-home",
          action: async () => {
            await import("@/wc/pages/portfolio/pages/home/index");
          },
        },
        {
          path: "/documents/:id",
          component: "pages-portfolio-pages-view-document",
          action: async () => {
            await import("@/wc/pages/portfolio/pages/viewDocument/index");
          },
        },
      ],
    },
    {
      name: "portfolio-anon",
      path: "/:nickname/portfolio",
      component: "pages-portfolio",
      action: async () => {
        Store.app.setRoute("portfolio");
        await installPortfolio();
      },
      children: [
        {
          path: "/",
          component: "pages-portfolio-pages-home",
          action: async () => {
            await import("@/wc/pages/portfolio/pages/home/index");
          },
        },
        {
          path: "/documents/:id",
          component: "pages-portfolio-pages-view-document",
          action: async () => {
            await import("@/wc/pages/portfolio/pages/viewDocument/index");
          },
        },
      ],
    },
    {
      name: "project",
      path: "/projects/:projectId",
      component: "pages-project",
      action: async () => {
        Store.app.setRoute("project");
        await installProject();
      },
    },
    {
      name: "onboarding",
      path: "/",
      component: "nw-project-features-onboarding",
      action: async () => {
        if (Store.user.isLoggedIn.value) {
          Store.app.setRoute("onboarding");
          Router.go(`/projects/${Store.project.id.value}`);
        }

        await import("@/wc/pages/project/features/onboarding");
      },
    },
  ]);

  return router;
};
